<template>
    <div>
        <!-- :label="field.label" -->
        <b-form-group
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for=""
                >{{ field.label
                }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label"
                    >({{ field.urduLabel }})</span
                ></label
            > -->
            <b-form-input
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                    email: !!field.isEmail,
                    numeric: setIsNumeric,
                    max: setMaxLength,
                    min: setMinLength,
                    alpha_num: field.isAlphaNum ? field.isAlphaNum : false,
                    alpha_spaces: field.isAlpha ? field.isAlpha : false,
                }"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :disabled="loading || isDisable || field.isDisabled"
                :data-vv-name="field.label"
                :maxlength="setMaxLength"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @keypress="keyPress"
                @keyup="keyUp"
                @paste="handlePaste"
                @blur="handleBlur"
            ></b-form-input>
        </b-form-group>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > inject
  |--------------------------------------------------------------------------
  */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {}, // End of Component > components
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        this.setMinLength = this.field.minLength
        this.setMaxLength = this.field.maxLength
        if (this.field.isNumeric) {
            if (this.field.key === 'identityInfo.number') {
                let idType =
                    this.$store.state.registration.form.identityInfo.type
                if (idType === 'passport') {
                    this.setNumeric = 'text'
                    this.setIsNumeric = false
                    this.setMinLength = 9
                    this.setMaxLength = 9
                } else {
                    //console.log('number sent')
                    this.setNumeric = 'number'
                    this.setIsNumeric = true
                }
            } else {
                this.setNumeric = 'number'
                this.setIsNumeric = true
            }
        } else {
            this.setNumeric = 'text'
            this.setIsNumeric = false
        }
        return {
            value: '',
            isDisable: false,
        }
    }, // End of Component > data
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),
        urduLabel() {
            if (this.$store.state.registration.form.languageOption == 'urd') {
                return true
            } else {
                return false
            }
        },
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > Created
    |--------------------------------------------------------------------------
    */
    created() {
       
       
        if(this.field.key == 'occupationInfo.taxNo'){
             this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .taxStatus
                },
                (newValue) => {
                     let idNumber = this.$store.state.registration.form.identityInfo.number
                    if (newValue == 'Filer') {
                        
                        this.field.isRequired = false
                        this.isDisable = true
                        idNumber = idNumber.replace(/-/g, '')
                        this.writeValue(idNumber)
                    } else {
                        this.field.isRequired = false
                        this.isDisable = true
                         this.writeValue('')
                    }
                }
            )

        }
        if (
            this.field.key == 'accountInfo.guardianName' ||
            this.field.key == 'accountInfo.guardianRelationship' ||
            this.field.key == 'accountInfo.guardianCNIC' ||
            this.field.key == 'accountInfo.guardianMobileNo'
        ) {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .isMinorAccount
                },
                (newValue) => {
                    if (newValue == 'Yes') {
                        this.field.isRequired = true
                    } else {
                        this.field.isRequired = false
                         this.writeValue('')
                    }
                }
            )
        }

        if (this.field.key == 'accountInfo.operateAccountOther') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.accountInfo
                        .operateAccount // could also put a Getter here
                },
                (newValue, oldValue) => {
                    if (newValue == 'Others') {
                        this.isDisable = false
                        this.field.isRequired = true
                        // this.writeValue('')
                    } else {
                        this.isDisable = true
                        this.field.isRequired = false
                    }
                }
            )
        }

        if (this.field.key == 'fatcaInfo.PowerAttorneyAdd') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.fatcaInfo
                        .IsPowerAttorney // could also put a Getter here
                },
                (newValue, oldValue) => {
                    if (newValue == 'Yes') {
                        this.field.isDisabled = false
                        this.field.isRequired = true
                       
                    } else {
                        this.field.isDisabled = true
                        this.field.isRequired = false
                         this.writeValue('')
                    }
                }
            )
        }

        if (
            this.field.key == 'pepInfo.nameUBO' ||
            this.field.key == 'pepInfo.cnicUBO'
        ) {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.pepInfo
                        .declarationPEP8 // could also put a Getter here
                },
                (newValue, oldValue) => {
                    if (newValue == 'Yes') {
                        this.field.isDisabled = false
                        this.field.isRequired = true
                        
                    } else {
                        this.field.isDisabled = true
                        this.field.isRequired = false
                        this.writeValue('')
                    }
                }
            )
        }
    }, // End Component > Created
    mounted() {
        
        
        if(this.field.key == 'occupationInfo.taxNo'){
             this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .taxStatus
                },
                (newValue) => {
                    let idNumber = this.$store.state.registration.form.identityInfo.number
                    if (newValue == 'Filer') {
                       
                        this.field.isRequired = false
                        this.isDisable = true
                        idNumber = idNumber.replace(/-/g, '')
                        this.writeValue(idNumber)
                    } else {
                        this.field.isRequired = false
                        this.isDisable = true
                         this.writeValue('')
                    }
                }
            )

        }
        if (this.field.key == 'accountInfo.nomineeAllocation1') {
            let newValue = '100'
            this.writeValue(newValue)
            this.isDisable = true
        }

        if (this.field.key == 'accountInfo.operateAccountOther') {
            this.isDisable = true
        }
        // initialize if custom field
        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }
        if (this.field.key == 'contactInfo.email') {
            this.isDisable = true
        }
        if (this.field.key == 'identityInfo.number') {
            this.isDisable = true
        }
        if (this.field.key == 'fatcaInfo.PowerAttorneyAdd') {
            if (
                this.$store.state.registration.form.fatcaInfo.IsPowerAttorney ==
                'Yes'
            ) {
                this.field.isDisabled = false
                this.field.isRequired = true
            } else {
                this.field.isDisabled = true
                this.field.isRequired = false
            }
        }
        if (
            this.field.key == 'pepInfo.nameUBO' ||
            this.field.key == 'pepInfo.cnicUBO'
        ) {
            if (
                this.$store.state.registration.form.pepInfo.declarationPEP8 ==
                'Yes'
            ) {
                this.field.isDisabled = false
                this.field.isRequired = true
            } else {
                this.field.isDisabled = true
                this.field.isRequired = false
            }
        }

        if (
            this.field.key == 'accountInfo.guardianName' ||
            this.field.key == 'accountInfo.guardianRelationship' ||
            this.field.key == 'accountInfo.guardianCNIC' ||
            this.field.key == 'accountInfo.guardianMobileNo'
        ) {
            if (
                this.$store.state.registration.form.basicInfo.isMinorAccount ==
                'Yes'
            ) {
                this.field.isRequired = true
            } else {
                this.field.isRequired = false
            }
        }
        // End
    }, // End of Component > computed
    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        handleBlur() {
            this.$root.$emit('updateTempCustomer')
        },
        handlePaste(event){
            event = event ? event : window.event;
            if (this.field.key == 'accountInfo.bankTitle') {
                const lettersOnly = /^[a-zA-Z ]+$/;
                const value = event.clipboardData.getData('text');  
                if(!lettersOnly.test(value)){
                    event.preventDefault();
                }
            }

        },
        keyUp() {
            /*
          | -------------------------------------------
          | Expected Credit field is in Amount
          | -------------------------------------------
          */
            if (
                this.field.key == 'accountInfo.expectedCredit' ||
                this.field.key == 'accountInfo.initialBalance' ||
                this.field.key == 'accountInfo.creditLimit'
            ) {
                let b = this.value
                if (!b.length) {
                    b = null
                } else {
                    let x = b.replace(/[^0-9\.]/g, '')

                    // console.log('X : ' + x)
                    if (x) {
                        let y = parseInt(x).toLocaleString()
                        // console.log('Y : ' + y)
                        this.writeValue(y)
                    } else {
                        this.writeValue(null)
                    }
                }
            } // End Expected Credit field is in Amount
        }, // End KeyUp
        keyPress(event) {
            /*
          | -------------------------------------------
          | Numeric Field (Only Numeric Allow)
          | -------------------------------------------
          */
            if (
                this.field.isNumeric &&
                this.$store.state.registration.form.identityInfo.type !=
                    'passport'
            ) {
                event = event ? event : window.event
                let charCode = event.which ? event.which : event.keyCode
                // console.log("char code ", charCode)
                if (
                    charCode > 31 &&
                    (charCode < 48 || charCode > 57) &&
                    charCode !== 46
                ) {
                    event.preventDefault()
                } else {
                    return true
                }
            } // End Numeric Field

            /*
          | -------------------------------------------
          | Alphabetic Field (Only alphabets and spaces Allow for religion)
          | -------------------------------------------
          */
            // if (this.field.key == 'basicInfo.religion') {
            //     event = event ? event : window.event
            //     let charCode = event.which ? event.which : event.keyCode
            //     // console.log("char code ", charCode)
            //     if (
            //         (charCode > 64 && charCode < 91) ||
            //         (charCode > 96 && charCode < 123) ||
            //         charCode == 8 ||
            //         charCode == 32
            //     ) {
            //         return true
            //     } else {
            //         event.preventDefault()
            //     }
            // }
            /*
          | -------------------------------------------
          | Account Title Field (Allow /-,space letters and numbers only)
          | -------------------------------------------
          */
            if (this.field.key == 'accountInfo.bankTitle') {
                event = event ? event : window.event
                let charCode = event.which ? event.which : event.keyCode
                const lettersOnly = /^[a-zA-Z ]+$/;
                const value = event.key;
                if(!lettersOnly.test(value)){
                    event.preventDefault();
                }
                // if (
                //     // (charCode > 47 && charCode < 58) ||  // numeric
                //     (charCode > 64 && charCode < 91) ||
                //     (charCode > 96 && charCode < 123) ||
                //     charCode == 8 ||
                //     charCode == 32 ||
                //     charCode == 44 ||
                //     charCode == 47
                //     // charCode == 45 // - dash
                // ) {
                //     return true
                // } else {
                //     event.preventDefault()
                // }
            }
        }, // End KeyPress
        numeric() {
            if (this.field.key == 'identityInfo.number') {
                return false
            } else {
                return !!this.field.isNumeric
            }
        },
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        },
    }, // End of Component > mounted
}
</script>
